import React, { type PropsWithChildren } from 'react';
import { MenuItemBase } from './MenuItemBase';

type Props = {
  itemsinrow: number;
  id: string;
  className: string;
  showatstart: string;
  columnscount: number;
  showpromotedproduct: number;
  megamenusubmenulayout: number;
  showproductname: number;
  showproductshortdescription: boolean;
  useablock: boolean;
  maxwidth: string;
} & PropsWithChildren;

const menuItemBaseType = React.createElement(MenuItemBase).type;

export function ImageMenu(props: Props) {
  return (
    <nav
      id={props.id}
      role="menu"
      aria-label="Main menu"
      className={props.className}
    >
      {[props.children]
        .flat()
        .filter(
          (x) =>
            x != null &&
            typeof x === 'object' &&
            'type' in x &&
            x?.type === menuItemBaseType
        )
        .map((item) => {
          const { href, text, icon, target, alt, hidden } = (
            item as React.ReactComponentElement<typeof MenuItemBase>
          ).props.attribs;
          if (href == null) return null;

          // If the menu item is hidden, ensure it is not focusable
          if (hidden) {
            return (
              <div
                key={icon}
                aria-hidden="true"
                className={`${props.className}_item`}
                style={{ display: 'none' }}
              >
                <img src={icon} alt={alt} title={text} />
              </div>
            );
          }

          return (
            <a
              key={icon}
              role="menuitem"
              href={href}
              className={`${props.className}_item`}
              target={target}
            >
              <img src={icon} alt={alt} title={text} />
            </a>
          );
        })}
    </nav>
  );
}

export default ImageMenu;
